import { Controller, useFormContext } from 'react-hook-form';

import { AkselLocale, Switch as AkselSwitch } from 'components/form/aksel';

export default function Switch({
	name,
	label,
	labelPlacement = 'end',
	defaultChecked = false,
	disabled = false,
	// eslint-disable-next-line no-unused-vars -- Unused legacy prop.
	formGroupProps = {},
	...rest
}) {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultChecked}
			render={({ field: { onChange, value, ...fieldProps } }) => (
				<AkselLocale>
					<AkselSwitch
						position={labelPlacement === 'start' ? 'right' : 'left'}
						disabled={disabled}
						checked={!!value}
						onChange={event => onChange(event.target.checked)}
						{...fieldProps}
						{...rest}
					>
						{label}
					</AkselSwitch>
				</AkselLocale>
			)}
		/>
	);
}
